/*
 * Correspondance MonAppliClub :
 *
 * 1 = Administrateur
 * 2 = Utilisateur
 * 3 = Enseignant
 *
 * À adapter si un site possède une
 * correspondance différente.
 */
const TUTORIAL_ROLE_BY_ID = {
  1: "administrateur",
  2: "utilisateur",
  3: "enseignant",

};

export function getTutorialRole(
  user
) {
  if (!user) {
    return null;
  }

  const roleId = Number(
    user.role_id ??
      user.roleId ??
      user.Role?.id ??
      user.role?.id
  );

  return (
    TUTORIAL_ROLE_BY_ID[roleId] ||
    null
  );
}

export function getTutorialRoleLabel(
  role
) {
  const labels = {
    utilisateur: "Utilisateur",
    enseignant: "Enseignant",
    administrateur: "Administrateur",
  };

  return labels[role] || "Utilisateur";
}